import { doc, getDocFromServer } from 'firebase/firestore';
import { db } from '@/firebase';
import { loadDomainPhasePolicy, phaseExecutionError } from './phaseRuntime.js';

export async function loadPhasePolicy(schoolId, domainId = 'discipline') {
  try {
    return await loadDomainPhasePolicy({ schoolId, domainId, read: async (collection, id) => {
      const saved = await getDocFromServer(doc(db, 'schools', schoolId, collection, id));
      return saved.exists() ? saved.data() : null;
    } });
  } catch (error) {
    throw phaseExecutionError(error.message || 'The school’s phase process could not be checked. Retry when connected.');
  }
}
